/* eslint-disable react/jsx-no-bind */
import React, { useEffect, useState } from 'react';
import { AnimatedImage, Input, Typography } from 'ui';
import { Button } from 'ui';
import { Modal } from 'ui';
import { toast } from 'react-hot-toast';
import {
  phoneNumberValidation,
  pincodeValidation,
} from 'core-lib/utils/validation';
import { isAlphabetsWithSpace } from 'core-lib/utils/regex';
import { trackBookTestDrive } from 'src/modules/newCars/utils/events';
import s from './UserDetailPopup.module.scss';
import postUserLead from 'src/modules/newCars/services/postUserLead';
import { Color, TypeScales } from 'ui/primitives';
import { useSelector } from 'react-redux';

type tempFormDataType = {
  name: {
    value: string;
    hasError: boolean;
    errMsg: string;
  };
  contact: {
    value: number;
    hasError: boolean;
    errMsg: string;
  };
  pincode: {
    value: number;
    hasError: boolean;
    errMsg: string;
  };
};

const tempFormData: tempFormDataType = {
  name: {
    value: '',
    hasError: false,
    errMsg: '',
  },
  contact: {
    value: null,
    hasError: false,
    errMsg: '',
  },
  pincode: {
    value: 123456,
    hasError: false,
    errMsg: '',
  },
};
export const UserDetailPopup = ({
  show,
  onClose,
  brandName,
  modelName,
  onSubmit,
}: {
  show: boolean;
  onClose: () => void;
  brandName?: string;
  modelName?: string;
  onSubmit?: () => void;
}) => {
  const [formData, setFormData] = useState<tempFormDataType>(tempFormData);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const { profile, isAuthenticated } = useSelector((state: any) => state?.auth);
  console.log(profile);
  const {
    phone_number: phoneNumber,
    full_name: fullName,
    home_address: homeAddress,
  } = profile;

  function handleChange(key, value) {
    if (key === 'name') {
      setFormData((state) => ({
        ...state,
        name: { value, hasError: false, errMsg: '' },
      }));
    } else if (key === 'contact') {
      setFormData((state) => ({
        ...state,
        contact: { value, hasError: false, errMsg: '' },
      }));
    } else if (key === 'pincode') {
      setFormData((state) => ({
        ...state,
        pincode: { value, hasError: false, errMsg: '' },
      }));
    }
  }

  async function handleSubmit() {
    let error = false;
    let tempObj = formData;

    if (formData?.name?.value.length === 0) {
      tempObj = {
        ...tempObj,
        name: {
          value: formData.name.value,
          errMsg: 'This is required field',
          hasError: true,
        },
      };
      error = true;
    }
    const isNameValid = isAlphabetsWithSpace(formData?.name?.value);

    if (!isNameValid) {
      tempObj = {
        ...tempObj,
        name: {
          value: formData.name.value,
          errMsg: 'Enter valid name',
          hasError: true,
        },
      };
      error = true;
    }

    const phoneValidation = phoneNumberValidation(formData?.contact?.value);
    if (phoneValidation.errMsg) {
      error = true;
      tempObj = {
        ...tempObj,
        contact: {
          value: formData?.contact?.value,
          errMsg: phoneValidation.errMsg,
          hasError: true,
        },
      };
    }
    const pinValidation = pincodeValidation(formData?.pincode?.value);
    if (pinValidation.errMsg) {
      error = true;
      tempObj = {
        ...tempObj,
        pincode: {
          value: formData?.pincode?.value,
          errMsg: pinValidation.errMsg,
          hasError: true,
        },
      };
    }
    if (error) {
      //return
    } else {
      const data = {
        category: 'car-listing',
        name: formData?.name?.value,
        contactNumber: formData?.contact?.value,
        pincode: formData?.pincode?.value,
        brand: brandName,
        model: modelName,
      };
      const response: any = await postUserLead({ data });
      if (response) {
        setSubmitSuccess(true);
        setTimeout(() => {
          onClose();
        }, 3000);
      }
      trackBookTestDrive(
        formData?.name?.value,
        formData?.contact?.value,
        formData?.pincode?.value,
        brandName,
        modelName
      );
      if (onSubmit) {
        onSubmit();
      }
    }
    setFormData(tempObj);
  }

  useEffect(() => {
    if (isAuthenticated) {
      if (phoneNumber) {
        handleChange('contact', phoneNumber);
      }
      if (fullName) {
        handleChange('name', fullName);
      }
      if (homeAddress?.pincode) {
        handleChange('pincode', homeAddress?.pincode);
      }
    }
  }, [isAuthenticated, phoneNumber, fullName]);

  return (
    <Modal
      show={show}
      isWeb
      head={{
        show: true,
        title: 'Enter your full name and contact details to get offers',
        onClose: onClose,
      }}
      closeOnClickOutside
      animation={{ type: 'fadeAfter', timeout: 's' }}
      variant={submitSuccess ? 'popup' : 'bottomSheet'}
      rootStyle={{
        zIndex: 10,
      }}
    >
      {submitSuccess ? (
        <div className={s.success}>
          <AnimatedImage src="/img/newCars/success.gif" />
          <Typography
            label="Thank you for booking a test drive!"
            variant={TypeScales.h3}
          />
          <Typography
            label="Our partners will contact you soon!"
            variant={TypeScales.h4_light}
            color={Color.text_subheading}
          />
        </div>
      ) : (
        <div className={s.root}>
          <div className={s.name}>
            <Input
              label="Full name"
              value={formData?.name?.value}
              onChange={(e) => handleChange('name', e.currentTarget.value)}
              hasError={formData?.name?.hasError}
              errorMessage={formData?.name?.errMsg}
            />
          </div>
          <div className={s.number}>
            <Input
              label="Contact number"
              value={formData?.contact?.value}
              onChange={(e) => handleChange('contact', e.currentTarget.value)}
              maxLength={10}
              hasError={formData?.contact?.hasError}
              errorMessage={formData?.contact?.errMsg}
              type="number"
            />
          </div>
          <div className={s.number}>
            <Input
              label="Pincode"
              value={formData?.pincode?.value}
              onChange={(e) => handleChange('pincode', e.currentTarget.value)}
              maxLength={10}
              hasError={formData?.pincode?.hasError}
              errorMessage={formData?.pincode?.errMsg}
              type="number"
            />
          </div>
          <Button label="Submit" onClick={handleSubmit} fullwidth />
        </div>
      )}
    </Modal>
  );
};
